// extracted by mini-css-extract-plugin
export var errorBanner = "_dq-2";
export var scroller = "_dq-0";
export var thinking = "_dq-1";
export var visuallyHidden = "_dq-3";